import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useNotifications(status = 'open') {
  return useQuery({
    queryKey: ['notifications', status],
    queryFn: () => api.get(`/notifications?status=${status}`),
    staleTime: 30_000,
  });
}

export function useNotificationsCount(status = 'open') {
  return useQuery({
    queryKey: ['notifications', 'count', status],
    queryFn: () => api.get(`/notifications/count?status=${status}`),
    staleTime: 30_000,
    select: (data) => data?.total ?? 0,
  });
}

function useNotifMutation(mutateFn) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: mutateFn,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['categories'] });
    },
  });
}

export function useDismissNotification() {
  return useNotifMutation((id) => api.post(`/notifications/${id}/dismiss`, {}));
}

export function useResolveNotification() {
  return useNotifMutation((id) => api.post(`/notifications/${id}/resolve`, {}));
}
